import { consultants } from './consultant-data';

/**
 * Resolves an agency name from its ID or returns the input if it's already a name.
 * Supports the new hardcoded test IDs.
 */
export function getAgencyName(idOrName: string | undefined): string {
    if (!idOrName) return '';
    
    // Check our hardcoded consultants list first
    const consultant = consultants.find(c => c.id === idOrName);
    if (consultant && consultant.company) {
        return consultant.company;
    }
    
    // Direct mapping for known test IDs if not found in list (safety fallback)
    const testAgencies: { [key: string]: string } = {
        '2604PNBD0GH87': 'M Nayon Overseas Limited',
        '2604PNBD0RB88': 'Gulam Rabbi International Ltd.',
        '2604PNBD0FL89': 'Flamenco Overseas Ltd.',
        '2604PNBD0CR90': 'M/S. Country Road International'
    };
    
    if (testAgencies[idOrName]) {
        return testAgencies[idOrName];
    }
    
    return idOrName;
}

/**
 * Mapping of agency IDs to their logo paths in the public directory.
 */
export const AGENCY_LOGOS: Record<string, string> = {
    '2604PNBD0GH87': '/img/BANGLADESH/TRANGDOITAC/M Nayon Overseas Limited.png',
    '2604PNBD0RB88': '/img/BANGLADESH/TRANGDOITAC/Gulam Rabbi International Ltd..png',
    '2604PNBD0FL89': '/img/BANGLADESH/TRANGDOITAC/Flamenco Overseas Ltd..png',
    '2604PNBD0CR90': '/img/BANGLADESH/TRANGDOITAC/MS. Country Road International.png',
};

/**
 * Checks if an agency ID belongs to the hardcoded mock/test list.
 * @deprecated logic is being removed as requested
 */
export function generateAgencyCode(): string {
    const date = new Date();
    const yy = date.getFullYear().toString().slice(2);
    const mm = (date.getMonth() + 1).toString().padStart(2, '0');
    const rand = Math.random().toString(36).substring(2, 7).toUpperCase();
    return `${yy}${mm}PNBD${rand}`;
}
